import { useState, useEffect, useContext } from "react";
import axios from "axios";
import Nav from "../Nav";
import Mycontext from "../Mycontext";
import Logout from "../logout/Logout";
import { useNavigate, Link } from "react-router-dom";
import { baseUrl } from "../constant.js";
import Logoutmodule from "../logout/Logoutmodule";
import Modal from "react-modal";
import Theme from "../Theme";
import { liveRateUrl } from "../constant.js";
import { useLocation } from "react-router-dom";
Modal.setAppElement("#root");
const Portfolio = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [response, setResponse] = useState("");
  const [responseheader, setResponseHeader] = useState("Are You Sure ?");
  const [image, setimage]=useState("")
  const [err, setError] = useState("");
  const [status, setStatus] = useState("");
  const [data, setData] = useState([]);
  const [orderid, setorderid] = useState("");
  const [type, setType] = useState("3");
  const [closedata, setclosedata] = useState("");
  const [active, setactive] = useState("1");
  const [colour, setcolour] = useState("");
  const [closeOrderID, setcloseOrderID] = useState();
  const [notification, setnotification] = useState();
  console.log(response )
  console.log(status)
  console.log(image)
 

  const getdatanotification = async () => {
    const Token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("Token", Token);

    const result = await axios.post(
      baseUrl + `authController/getNotificationList`,
      formData,
    );
    setnotification(result.data.data);
  };

  console.log(response);
  console.log(data);
  const title = localStorage.getItem("title");
  const exparydate = localStorage.getItem("exparydate");
  const token = localStorage.getItem("token");
  const catid = localStorage.getItem("catid");
  const high = localStorage.getItem("high");
  const low = localStorage.getItem("low");
  const ltp = localStorage.getItem("ltp");
  const buy = localStorage.getItem("buy");
  const sell = localStorage.getItem("sell");
  const changeprice = localStorage.getItem("changeprice");
  const percentagepricechange = localStorage.getItem("percentagepricechange");

  const navigate = useNavigate();

  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setStatus(0);
    setIsOpen(false);
    setResponse()
    setResponseHeader("Are You Sure ?")
    setimage()

    //navigate("/trades")
  };
  const closeModal2 = () => {
    setIsOpen(false);
  };
  const customStyles = {
    content: {
      width: "200px",
      height: "150px",
      margin: "auto",
      border: "1px solid #ccc",
    },
  };
  const getdata = async () => {
    const Token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("Token", Token);

    const result = await axios.post(
      baseUrl + `authController/getPortfolioList`,
      formData,
    );

    if ((await result.data.is_login) === 0) {
      localStorage.removeItem("Name");
      localStorage.removeItem("userCode");
      localStorage.removeItem("token");
      navigate("/login");
    }
    setData(result.data);
  };

  useEffect(() => {
    const auth = localStorage.getItem("token");
    if (auth) {
      navigate("/portfolio");
    } else {
      navigate("/login");
    }
    getdata();
    closetrade();
    getdatanotification();
    const timer = setInterval(() => {
      getdata();
    }, 3000);
  }, []);

  // const onbuttonclick = async () => {
  //   const name = localStorage.getItem("name");
  //   navigate("/markettrade", { state: { name: name } });
  //   localStorage.removeItem("name");
  // };

  const closetrade = async () => {
    const Token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("Token", Token);
    const closeddata = await axios.post(
      baseUrl + `authController/getClosePortfolioList`,
      formData,
    );
    setclosedata(closeddata.data);
  };
  const ordertype = async () => {
    const token = localStorage.getItem("token");
    const formdata = new FormData();
    formdata.append("Token", token);
    formdata.append("orderID", closeOrderID);
    formdata.append("type", type);
    const result = await axios.post(
      baseUrl + `authController/closeCancelTrade`,
      formdata,
    );
    setResponse(result.data.message);
    setStatus(result.data.status);
    if(result.data.status === 1)
    {
      setResponseHeader("Success");
      setimage("assets/img/icons/checked.png")
    }
    else{
      setResponseHeader("Failed");
      setimage("assets/img/icons/failed.png")
    }
    closetrade();
    openModal();
    
    
    
  };
  const onbuttonclick = async (
    category_name,
    instrument_token,
    category_id,
    expire_date,
  ) => {
    // console.log("catname", category_name);

    const token1 = instrument_token;

    const tokenheader = localStorage.getItem("token");
    const formdata = new FormData();
    formdata.append("Token", tokenheader);
    formdata.append("catToken", token1);
    const rate = await axios.post(liveRateUrl, formdata);

    const fathdata = await rate.data.livedata[0];

    navigate("/markettrade", {
      state: {
        name: category_name,
        token: token1,
        catid: category_id,
        exparydate: expire_date,
      },
    });
  };
  return (
    <section className="marketwatch_pg online_trade_view">
      <div className="list_market_row text-center">
        <div className="onine_view_col">
          <div className="phone_frame">
            <div className="frame_screen">
              <div className="screen_body main_screenUI">
                <div className="dashboard_main">
                  <div className="dashboard_header">
                    <Logoutmodule />
                    {/* <div>
                          {notification &&
                            notification.map((item) => (
                              <marquee>
                                {" "}
                                <p style={{ color: "white" }}>
                                  {item.message} ,
                                </p>
                              </marquee>
                            ))}
                        </div> */}
                    <div>
                      <a
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#color_modal"
                      >
                        <img
                          src="assets/img/icons/colour.png"
                          className="img-fluid color_icons"
                          alt=""
                        />
                      </a>
                    </div>
                  </div>

                  <div className="market_tab_col">
                    <div className="tab-content dashboard_col_tabs">
                      <div className="dashboard_tabs_colm">
                        <ul
                          className="dashboard_col_nav nav nav-tabs"
                          role="tablist"
                        >
                          <li className="nav-item">
                            <a
                              className="nav-link active"
                              id="active"
                              data-bs-toggle="tab"
                              type="button"
                              role="tab"
                              aria-controls="active-tabs"
                              aria-selected="true"
                              onClick={() => setactive(1)}
                              style={{ color: "#0aff0a" }}
                            >
                              Active
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link "
                              id="close"
                              data-bs-toggle="tab"
                              type="button"
                              role="tab"
                              aria-controls="close-tabs"
                              aria-selected="true"
                              onClick={() => setactive(2)}
                              style={{ color: "red" }}
                            >
                              Close
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="tab-content">
                        {active == 1 && (
                          <div
                            className="tab_search_body fade show active"
                            id="active-tabs"
                            role="tabpanel"
                            aria-labelledby="active"
                          >
                            <div className="market_trades_colm">
                              <div className="balance_colm">
                                <div className="balance_colm_box">
                                  <h5>Ledger Balance</h5>
                                  <h3>
                                    {" "}
                                    {Number(data.totalLedgerBalance).toFixed(2)}
                                  </h3>
                                </div>
                                <div className="balance_colm_box">
                                  <h5>Margin Available</h5>
                                  <h3>
                                    {Number(data.totalMarginBalance).toFixed(2)}
                                  </h3>
                                </div>
                                <div className="balance_colm_box">
                                  <h5>Active P/L</h5>
                                  {data.totalPLBalance > 0 && (
                                    <h3 style={{ color: "green" }}>
                                      {Number(data.totalPLBalance).toFixed(2)}
                                    </h3>
                                  )}
                                  {data.totalPLBalance < 0 && (
                                    <h3 style={{ color: "red" }}>
                                      {Number(data.totalPLBalance).toFixed(2)}
                                    </h3>
                                  )}
                                  {data.totalPLBalance == 0 && (
                                    <h3>
                                      {Number(data.totalPLBalance).toFixed(2)}
                                    </h3>
                                  )}
                                </div>
                                <div className="balance_colm_box">
                                  <h5>M2M</h5>
                                  <h3>
                                    {Number(data.totalM2MBalance).toFixed(2)}
                                  </h3>
                                </div>
                              </div>
                              <div
                                className="balance_colm_bottom"
                                style={{ borderTop: "1px solid" }}
                              >
                                <h3>
                                  Require Holding Margin:{" "}
                                  {Number(data.totalRequiredMargin).toFixed(2)}
                                </h3>
                              </div>
                            </div>

                            {data.data
                              ? data.data.map((item) => (
                                  <div
                                    className="market_bought_details"
                                    style={{
                                      borderBottom: "1px solid",
                                      paddingBottom: "15px",
                                    }}
                                  >
                                    <div className="bought_content text-left">
                                      <Link
                                        onClick={() =>
                                          onbuttonclick(
                                            item.category_name,
                                            item.instrument_token,
                                            item.category_id,
                                            item.expire_date,
                                          )
                                        }
                                      >
                                        <h5>
                                          {item.category_name}-
                                          {item.expire_date}
                                        </h5>
                                        <p>Margin:{item.intradayMargin}</p>

                                        <p>
                                          Holding Margin:
                                          {item.holdingMargin}
                                        </p>
                                      </Link>
                                    </div>
                                    <div className="bought_content text-right">
                                      {/* <button onClick={onbuttonclick}>
                                            hello
                                          </button> */}

                                      {item.bid_type == 1 && (
                                        <h5>
                                          <span style={{ color: "green" }}>
                                            {" "}
                                            Bought:{" "}
                                          </span>
                                          {item.lot}@{item.avrageBidPrice}
                                        </h5>
                                      )}
                                      {item.bid_type == 2 && (
                                        <h5>
                                          <span style={{ color: "Red" }}>
                                            {" "}
                                            Sold:{" "}
                                          </span>
                                          {item.lot}@{item.avrageBidPrice}
                                        </h5>
                                      )}
                                      <p>
                                        {item.pl_balance > 0 && (
                                          <span style={{ color: "green" }}>
                                            +{item.pl_balance}
                                          </span>
                                        )}
                                        {item.pl_balance < 0 && (
                                          <span style={{ color: "red" }}>
                                            {item.pl_balance}
                                          </span>
                                        )}
                                        CMP {item.cmprate}
                                      </p>

                                      <button
                                        type="button"
                                        onClick={() => {
                                          {
                                            setcloseOrderID(item.category_id);
                                            openModal();
                                          
                                          }
                                        }}
                                        d
                                        style={{
                                          border: "1px solid #ed0017",
                                          padding: "2px 10px",
                                          color: "#fff",
                                          borderRadius: "5px",
                                          fontSize: "10px",
                                          background: "#ed0017",
                                        }}
                                      >
                                        Close Order
                                      </button>
                                    </div>
                                  </div>
                                ))
                              : "hi"}
                          </div>
                        )}
                        <div
                          className="tab_search_body"
                          id="close-tabs"
                          role="tabpanel"
                          aria-labelledby="close"
                        >
                          {active == 2 && (
                            <div className="tab-content">
                              <div
                                className="tab_search_body fade show  "
                                id="active-tabs"
                                role="tabpanel"
                                aria-labelledby="active"
                              >
                                <div className="market_trades_colm">
                                  <div className="balance_colm">
                                    <div className="balance_colm_box">
                                      <h5>Ledger Balance</h5>
                                      <h3>
                                        {" "}
                                        {Number(
                                          closedata.totalLedgerBalance,
                                        ).toFixed(2)}{" "}
                                      </h3>
                                    </div>
                                    <div className="balance_colm_box">
                                      <h5>Profit Loss</h5>
                                      <h3>
                                        {Number(
                                          closedata.totalPLBalance,
                                        ).toFixed(2)}
                                      </h3>
                                    </div>
                                    <div className="balance_colm_box">
                                      <h5>Total Brokerage</h5>
                                      <h3>
                                        {Number(
                                          closedata.totalBrokerage,
                                        ).toFixed(2)}
                                      </h3>
                                    </div>
                                    <div className="balance_colm_box">
                                      <h5>Net Profit/Loss</h5>
                                      <h3>
                                        {Number(
                                          closedata.netProfitLoss,
                                        ).toFixed(2)}
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                                {closedata.data
                                  ? closedata.data.map((item) => (
                                      <div
                                        className="market_bought_details"
                                        style={{
                                          borderBottom: "1px solid",
                                          paddingBottom: "15px",
                                        }}
                                      >
                                        <div className="bought_content text-left">
                                          <h5>
                                            {item.category_name}_
                                            {item.expire_date}
                                          </h5>
                                          <p>Avg. Sell: {item.avgSellPrice}</p>
                                          <p style={{ display: "inline" }}>
                                            Net Profit Loss:
                                            {item.pl_balance > 0 && (
                                              <span
                                                style={{
                                                  color: "green",
                                                  display: "inline",
                                                }}
                                              >
                                                {Number(
                                                  item.pl_balance,
                                                ).toFixed(2)}
                                              </span>
                                            )}{" "}
                                            {item.pl_balance < 0 && (
                                              <span
                                                style={{
                                                  color: "red",
                                                  display: "inline",
                                                }}
                                              >
                                                {Number(
                                                  item.pl_balance,
                                                ).toFixed(2)}
                                              </span>
                                            )}
                                          </p>
                                        </div>
                                        <div className="bought_content text-right">
                                          <h5>
                                            <span> Qty:{item.lot}</span>
                                          </h5>
                                          <p>
                                            <span></span>Avg.Buy:{" "}
                                            {item.avgBuyPrice}
                                          </p>
                                          <p>
                                            <span></span>Brokrage:{" "}
                                            {Number(item.brokerage).toFixed(2)}
                                          </p>
                                        </div>
                                      </div>
                                    ))
                                  : ""}
                              </div>
                              <div
                                className="tab_search_body"
                                id="close-tabs"
                                role="tabpanel"
                                aria-labelledby="close"
                              ></div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <Theme />
                  <Nav />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {status == 0 && (
        <Modal
          isOpen={isOpen}
          onRequestClose={closeModal2}
          style={customStyles}
        >
          <img
            
             src={image}
            className="img-fluid color_icons"
          />
          <h2>{responseheader}</h2>
          <p>{response}</p>
          <button
            onClick={closeModal}
            style={{ color: "red", background: "none" }}
          >
            DECILNE
          </button>
          <button
            onClick={() => {
              ordertype();
             closeModal()
            }}
          >
            Ok
          </button>
        </Modal>
      )}

      {status == 1 && (
        <Modal
          isOpen={isOpen}
          onRequestClose={closeModal2}
          style={customStyles}
        >
          <img
            
             src={image}
            className="img-fluid color_icons"
          />
          <h2>{responseheader}</h2>
          <p>{response}</p>
          <button onClick={closeModal}>Ok</button>
        </Modal>
      )}

{status == 0 && responseheader=="Failed" &&(
        <Modal
          isOpen={isOpen}
          onRequestClose={closeModal2}
          style={customStyles}
        >
          <img
            
             src={image}
            className="img-fluid color_icons"
          />
          <h2>{responseheader}</h2>
          <p>{response}</p>
          <button onClick={closeModal}>Ok</button>
        </Modal>
      )}

    </section>
  );
};
export default Portfolio;
